import { render, staticRenderFns } from "./DatenschutzFiliale.vue?vue&type=template&id=7675eb6e"
import script from "./DatenschutzFiliale.vue?vue&type=script&lang=ts"
export * from "./DatenschutzFiliale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports